package ai.beakman.undercover.data

import ai.beakman.undercover.i18n.I18n
import ai.beakman.undercover.i18n.Language
import ai.beakman.undercover.model.Theme
import ai.beakman.undercover.model.WordHint

/**
 * Banco de temas → palavras + dicas, agora LOCALIZADO.
 *
 * O catálogo neutro de idioma vive em [ThemeCatalog] (ids/emoji/ordem); os textos por
 * idioma em `ThemeStrings_<lang>`. Um [Theme] é sempre um tema JÁ resolvido num idioma.
 *
 * Dicas propositalmente vagas: servem a várias palavras do mesmo tema, para o
 * infiltrado não acertar de cara.
 */
object Themes {
    private fun names(lang: Language): Map<String, String> = when (lang) {
        Language.EN -> ThemeStrings_en.NAMES
        Language.PT -> ThemeStrings_pt.NAMES
        Language.ES -> ThemeStrings_es.NAMES
    }

    private fun words(lang: Language): Map<String, WordHint> = when (lang) {
        Language.EN -> ThemeStrings_en.WORDS
        Language.PT -> ThemeStrings_pt.WORDS
        Language.ES -> ThemeStrings_es.WORDS
    }

    /** Todos os temas resolvidos no idioma [lang], na ordem oficial do catálogo. */
    fun localized(lang: Language): List<Theme> {
        val nameMap = names(lang)
        val wordMap = words(lang)
        return ThemeCatalog.THEMES.map { catalog ->
            Theme(
                id = catalog.id,
                name = nameMap[catalog.id] ?: catalog.id,
                emoji = catalog.emoji,
                words = catalog.wordIds.mapNotNull { wordMap[it] },
            )
        }
    }

    /** Tema [id] resolvido no idioma [lang], ou `null` se não existir. */
    fun byId(id: String, lang: Language): Theme? =
        ThemeCatalog.byId(id)?.let { catalog ->
            val nameMap = names(lang)
            val wordMap = words(lang)
            Theme(
                id = catalog.id,
                name = nameMap[catalog.id] ?: catalog.id,
                emoji = catalog.emoji,
                words = catalog.wordIds.mapNotNull { wordMap[it] },
            )
        }

    /** Atalho: todos os temas no idioma corrente do app (compat com chamadas antigas). */
    val ALL: List<Theme> get() = localized(I18n.current)

    /** Atalho: tema [id] no idioma corrente do app (compat com chamadas antigas). */
    fun byId(id: String): Theme? = byId(id, I18n.current)
}
